export default __webpack_public_path__ + "static/media/renBTC_white.bd9ea800.svg";